import axios from "axios";

const bareHost = (h) => h.replace(/^www\./, "");

// Use the page's own origin when it is the www/apex twin of the configured backend
// (the apex -> www redirect has no CORS headers, so cross-variant calls fail in browsers).
export const BACKEND_BASE = (() => {
  const configured = process.env.REACT_APP_BACKEND_URL;
  try {
    const u = new URL(configured);
    const here = window.location;
    if (u.host !== here.host && bareHost(u.hostname) === bareHost(here.hostname)) return here.origin;
  } catch (e) {
    // fall through to the configured URL
  }
  return configured;
})();

export const API = `${BACKEND_BASE}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("apex_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
